import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useState } from 'react'

import { DateInput } from '@/components'
import { MarketSegmentFilter } from '@/components/ListFilter'
import { usePlannerContext } from '@/context'
import { useToggle } from '@/hooks'
import usePlanner from '@/hooks/usePlanner/usePlanner'
import { PlannerItemResponse, ScheduledPlannerItem } from '@/types/Planner'

import { DayCalendar } from './DayCalendar'
import { ListView } from './ListView/ListView'
import PlannerItemDetail from './PlannerItemDetail/PlannerItemDetail'
import ViewToggle from './ViewToggle'

export const Planner = () => {
  const { selectedDate, setDate } = usePlannerContext()
  const { isShown: showCalendar, toggle } = useToggle(false)
  const plannerQuery = usePlanner()
  const plannerData = plannerQuery?.data?.dailyPlanner

  const onDateChange = (value) => {
    value && setDate(value)
  }

  const [visibleEvent, setVisibleEvent] = useState<PlannerItemResponse | ScheduledPlannerItem | null>(null)

  const onOpenEvent = (event: any) => {
    setVisibleEvent(event)
  }

  const onCloseEvent = () => {
    setVisibleEvent(null)
  }

  return (
    <div className="flex w-full flex-col pb-20 md:p-8">
      <div className="mb-2 mt-4 flex self-end px-4 md:mt-0 ">
        <MarketSegmentFilter />
      </div>
      <div className="mb-4 flex w-full justify-between px-4">
        <DateInput className="max-w-fit" handleChange={onDateChange} value={selectedDate} />

        <ViewToggle calendarVisible={showCalendar} toggle={toggle} />
      </div>
      {plannerQuery?.isLoading ? (
        <LoadSpinner className="mt-20 self-center icon-secondary" isCurrentColor={true} size={2} />
      ) : showCalendar ? (
        <DayCalendar data={plannerData} onEventClick={onOpenEvent} />
      ) : (
        <ListView data={plannerData} onEventClick={onOpenEvent} />
      )}
      <PlannerItemDetail item={visibleEvent} onClose={onCloseEvent} refetchPlanner={plannerQuery?.refetch} />
    </div>
  )
}
